<template>
  <div>
    <div v-if="fileList.length === 0" class="upload-box" @click="triggerUpload">
      <input
        ref="fileInput"
        type="file"
        style="display: none"
        accept="image/jpeg,image/png,application/pdf"
        @change="handleFileChange"
      />
      <div class="upload-content">
        <img class="upload-icon" src="@/assets/upload/upload.png" alt="" />
        <div class="upload-content-title">
          <span style="color: #4076f2">点击</span>上传文件
        </div>
        <div class="upload-content-desc">支持 JPEG, PNG, PDF 格式</div>
        <div class="upload-content-size">文件大小不能超过500Kb</div>
      </div>
    </div>
    <div v-else>
      <div class="upload-box" @click="handleBoxClick">
        <div class="upload-icon-box">
          <el-image
            ref="elImageRef"
            class="upload-icon-file"
            :src="fileObj.auditValue ? fileObj.auditValue : fileObj.value"
            :preview-src-list="[
              fileObj.auditValue ? fileObj.auditValue : fileObj.value,
            ]"
            :initial-index="0"
            @click="enableMaskClickClose"
          >
          </el-image>
          <div class="upload-icon-btn-box">
            <el-button
              type="primary"
              size="mini"
              @click.stop="handleDownloadOriginal"
              :style="{ marginRight: !fileObj.auditValue ? '0' : '40px' }"
              >下载原图</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click.stop="handleDownloadReview"
              v-if="fileObj.auditValue"
              >下载审核图</el-button
            >
          </div>
        </div>
        <div class="upload-edit-box" @click.stop>
          <i
            v-if="isDelete"
            class="el-icon-delete"
            style="cursor: pointer"
            @click="handleFileDelete"
          ></i>
          <div v-if="!isDelete"></div>
          <el-pagination
            background
            layout="pager"
            :page-size="1"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            :total="fileTotal"
          ></el-pagination>
        </div>
      </div>

      <TipDialog ref="TipDialogRef" @success="handleSuccess" />
      <PrescriptionImage ref="PrescriptionImageRef" :fileObj="fileObj" />
    </div>
  </div>
</template>

<script>
import TipDialog from "@/components/TipDialog/index.vue";
import PrescriptionImage from "@/components/PrescriptionImage/index.vue";

export default {
  name: "DocumentUpload",
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
    isDelete: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    fileList: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.fileObj = newVal[0];
          this.fileTotal = newVal.length;
          this.currentPage = 1;
        }
      },
      deep: true,
    },
  },
  components: {
    TipDialog,
    PrescriptionImage,
  },
  data() {
    return {
      fileObj: {},
      fileTotal: 0,
      currentPage: 1,
      isPreviewing: false,
    };
  },
  methods: {
    handleDownloadOriginal() {
      this.downloadImage(this.fileObj.value, this.fileObj.text);
    },
    handleDownloadReview() {
      this.downloadImage(this.fileObj.auditValue, this.fileObj.auditText);
    },
    downloadImage(url, name) {
      if (!url) return;
      fetch(url, {
        mode: "cors",
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error("网络响应失败");
          }
          return res.blob();
        })
        .then((blob) => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = name || "处方图片";
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href);
        })
        .catch((err) => {});
    },
    triggerUpload() {
      this.$refs.fileInput.click();
    },
    async handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      const formData = new FormData();
      formData.append("file", file);
      this.$emit("loading", true);
      const result = await this.$api.upload.AnalysisUpload(formData);
      if (result.code === 500) {
        this.$notify({
          title: result.message.title,
          type: "error",
          message: result.message.message,
          position: "bottom-right",
          duration: 4000,
          customClass: "notify-error-title",
        });
        this.$emit("loading", false);
        return;
      }
      this.fileList = result.data.imgs;
      this.fileObj = result.data.imgs[0];
      this.fileTotal = result.data.imgs.length;
      this.$emit("loading", false);
      this.$emit("successUpload", result.data);
      event.target.value = "";
    },
    reset() {
      this.fileList = [];
      this.fileObj = {};
      this.fileTotal = 0;
      this.currentPage = 1;
      this.isPreviewing = false;
    },
    handleCurrentChange(val) {
      this.fileObj = this.fileList[val - 1];
      this.$forceUpdate();
    },
    handleBoxClick(event) {
      if (this.isPreviewing) return;
      const target = event.target;
      if (
        target.closest(".el-image") ||
        target.closest(".upload-icon-btn-box") ||
        target.closest(".upload-edit-box")
      ) {
        return;
      }
      this.isPreviewing = true;
      event.stopPropagation();
      this.$nextTick(() => {
        const imageEl = this.$refs.elImageRef.$el.querySelector("img");
        if (imageEl) {
          imageEl.click();
        }
        setTimeout(() => {
          this.isPreviewing = false;
          this.enableMaskClickClose();
        }, 500);
      });
    },
    enableMaskClickClose() {
      this.$nextTick(() => {
        setTimeout(() => {
          const mask = document.querySelector(".el-image-viewer__mask");
          if (mask) {
            mask.style.cursor = "pointer";
            const closeHandler = () => {
              const closeBtn = document.querySelector(
                ".el-image-viewer__close"
              );
              if (closeBtn) {
                closeBtn.click();
              }
            };
            mask.onclick = closeHandler;
          }
        }, 100);
      });
    },
    handleFileDelete() {
      this.$refs.TipDialogRef.show({
        title: "注意",
        content: "是否清除文件？",
        successText: "确认",
        isTime: true,
      });
    },
    async handleSuccess() {
      this.reset();
      this.$emit("successDelete");
    },
    handlePrescriptionImage() {
      this.$refs.PrescriptionImageRef.show();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
